import {mapMutations, mapGetters} from "vuex";

export default {
    name: "changePassword",
    data() {
        return {}
    },
    methods: {
        ...mapMutations({
            changeShowPopUpPassword: 'auth/SHOW_CHANGE_PASSWORD_POPUP',
        }),
        loginUser() {
            this.changeShowPopUpLogin(true)
            this.changeShowPopUpNewPassword(false)
        }


    },
    computed: {
        ...mapGetters({
            showPopUpNewPasswordSuccess: 'auth/showPopUpNewPasswordSuccess',
        }),
    }
}

